<template>
  <div class="vc-panel" v-loading="showLoading">
    <EmptyView v-if="listBook.length == 0" @mainClick="gotoDownload" @optionClick="emptyOptionClick"
      mainButton="前往在线课程库下载" :options="emptyOptions"></EmptyView>
    <div v-else class="vh-full vh-flex">
      <div class="vc-flex toptools">
        <IconMenu @click="newBook" svgname="ic_add1" name="新建课程包" color="var(--ek-text-color2)" :iconSize="15"
          space="2px"></IconMenu>
      </div>
      <el-scrollbar class="vh-full">
        <div class="inrect">
          <div v-for="(item, i) in listBook" :key="item" class="bookitem" @click="gotoBookDetails(item)">
            <div class="bookitem-top vc-flex">
              <div class="icbox" :style="{ backgroundColor: bookColors[i % bookColors.length] }">
                <SvgIcon svgname="ic_book1" fill="white" :size="20"></SvgIcon>
              </div>
              <div>
                <div class="bookname">{{ item.bookName }}</div>
                <div class="subnum">课程数 {{ item.unitCount }}</div>
              </div>
            </div>
            <div class="vh-full bcent">
              <div class="lbsub">学习进度</div>
              <DoubleProgressBar class="mgt10" :color1="bookColors[i % bookColors.length]" :value1="item.learnProgress"
                :value2="item.masterProgress"></DoubleProgressBar>
              <div class="lbsub mgt20 spylast" v-if="item.lastUnitName != null && item.lastUnitName != ''">
                <span>{{ item.lastUnitName }}</span>
                <span class="spmg">●</span>
                <span>{{ item.lastLearnTime }}</span>
              </div>

            </div>
            <div class="bookitem-bottom">
              <div class="vc-flex">
                <IconView @click.stop="gotoBookDetails(item)" svgname="ic_right" :iconSize="16" :ctnSize="35">
                </IconView>
                <IconView @click.stop="editBook(item)" class="mgl10" svgname="ic_edit1" :iconSize="13" :ctnSize="35">
                </IconView>
                <IconView @click.stop="deleteBook(item)" class="mgl10" svgname="ic_delete" :iconSize="15" :ctnSize="35">
                </IconView>
              </div>
            </div>
          </div>
        </div>
      </el-scrollbar>
      <div class="vbot">
        <el-pagination layout="prev, pager, next,total,jumper" :total="pageInfo.totalCount" :page-size="pageInfo.size"
          @current-change="onPageChange" />
      </div>
    </div>
    <NewBookDialog :show="bookDialog.show" :book="bookDialog.editBook" @selectButton="bookDialog.callBack">
    </NewBookDialog>
    <ConfirmDialog :showDialog="confirmDialog.show" :title="confirmDialog.title" :message="confirmDialog.message"
      @selectButton="confirmDialog.callBack"></ConfirmDialog>
  </div>
</template>

<script>
import EmptyView from '@/components/EmptyView.vue';
import eventBus from '@/commom/event/EventBus';
import NewBookDialog from './dialog/NewBookDialog.vue';
import IconMenu from '@/components/IconMenu.vue';
import SvgIcon from '@/components/SvgIcon.vue';
import IconView from '@/components/IconView.vue';
import DoubleProgressBar from '@/components/DoubleProgressBar.vue';
import ConfirmDialog from '@/components/dialog/ConfirmDialog.vue';

import { useRouter } from 'vue-router'
import httpClient from '@/commom/http/httpClient';
const router = useRouter()

export default {
  name: 'MyBookList',
  components: {
    EmptyView,
    NewBookDialog,
    IconMenu,
    SvgIcon,
    IconView,
    DoubleProgressBar,
    ConfirmDialog
  },
  props: {

  },
  data() {
    return {
      showLoading: false,
      bookDialog: {
        editBook: null,
        show: false,
        callBack: null
      },
      confirmDialog: {
        show: false,
        title: "删除",
        message: "确认删除该课程包吗？",
        callBack: null
      },
      showNewBookDialog: false,
      emptyOptions: [
        { name: "新建课程包", key: "new-book", iconName: "ic_add1", iconSize: 16 }
      ],
      listBook: [],
      bookColors: [
        "#3C8CFF", "#00C0FF", "#00BC1F",
        "#EF3DFF", "#FFC500", "#9237FF",
        "#FF3131", "#FF7E00", "#48B04F"
      ],
      groupId: "",
      keyword: "",
      pageInfo: {
        index: 1,
        size: 20,
        totalCount: 0
      }
    }
  },
  mounted: function () {
    this.loadData()
  },
  methods: {
    ///加载数据
    loadData: function () {
      this.showLoading = true
      var that = this
      var req = {
        page: this.pageInfo.index,
        size: this.pageInfo.size,
        groupId: this.groupId,
        keyword: this.keyword
      }
      httpClient.invoke("UserBookAPI.GetPageList", req, function (res) {
        that.showLoading = false
        console.log("返回结果", res)
        if (res.error) {
          that.$message({ message: res.error })
          return
        }
        that.listBook = res.listItem
        if (that.pageInfo.index == 1) {
          that.pageInfo.totalCount = res.totalCount
        }
      })
    },
    ///加载第一页
    loadFirstPage: function () {
      this.pageInfo.index = 1
      this.loadData()
    },
    onPageChange: function (page) {
      this.pageInfo.index = page
      this.loadData()
    },
    ///前往下载
    gotoDownload: function () {
      eventBus.emit("mainPageEvent", { name: "gotoStore" })
    },
    ///空白视图选项点击
    emptyOptionClick: function (key) {
      switch (key) {
        case "new-book":
          this.newBook()
          break;
      }
    },
    ///创建课程库
    newBook: function () {
      this.bookDialog.editBook = null
      this.bookDialog.show = true
      var that = this
      this.bookDialog.callBack = function (res) {
        that.bookDialog.show = false
        if (res.confrim) {
          that.loadFirstPage()
        }
      }
    },
    ///编辑课程包
    editBook: function (book) {
      this.bookDialog.editBook = book
      this.bookDialog.show = true
      var that = this
      this.bookDialog.callBack = function (res) {
        that.bookDialog.show = false
        if (res.confrim) {
          that.loadData()
        }
      }
    },
    ///删除课程包
    deleteBook: function (book) {
      this.confirmDialog.message = "确认要删除此课程包吗？"
      this.confirmDialog.show = true
      var that = this
      this.confirmDialog.callBack = function (ok) {
        that.confirmDialog.show = false
        if (!ok) {
          return
        }
        var req = {
          bookId: book.bookId
        }
        httpClient.invoke("UserBookAPI.DeleteBook", req, function (res) {
          if (res.error) {
            that.$message({ message: res.error })
            return
          }
          //从listBook中删除
          that.listBook = that.listBook.filter(function (item) {
            return item.bookId != book.bookId
          })
          that.$message({ message: "删除成功" })
        })
      }
    },
    ///打开课程详情
    gotoBookDetails: function (book) {
      this.$router.push("/book-details-page/" + book.bookId)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.spmg {
  margin-left: 5px;
  margin-right: 5px;
  color: var(--ek-text-color3);
  font-size: 0.6rem;
}

.spylast {
  display: flex;
  align-items: center;
}

.vbot {
  padding-bottom: 10px;
  padding-left: 10px;
}

.lbsub {
  font-size: 14px;
  color: var(--ek-text-color2);
}

.bcent {
  padding-left: 20px;
  padding-top: 20px;
  padding-right: 20px;
}

.bookitem-bottom {
  padding-left: 20px;
  padding-bottom: 10px;
  padding-right: 20px;
}

.bookname {
  color: var(--ek-text-color1);
}

.subnum {
  font-size: 13px;
  color: var(--ek-text-color2);
}

.icbox {

  width: 2.5rem;
    height: 2.5rem;
  border-radius: 10px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bookitem-top {
  margin-top: 15px;
  margin-left: 20px;
  margin-right: 20px;
}

.toptools {
  margin-left: 20px;
  margin-right: 20px;
  padding-top: 5px;
  height: 50px;
  border-bottom: 1px solid var(--ek-split-lineColor2);
}

/* 网格容器样式 */
.inrect {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 15px;
  padding: 20px;
}

/* 书籍项样式 */
.bookitem {
  width: 100%;
  height: 250px;
  background-color: var(--ek-card-color1);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
  overflow: hidden;
  box-shadow: 5px 5px 5px #00000012;
}

/* 横屏平板 */
@media (min-width: 900px) and (max-width: 1200px) and (orientation: landscape) {
  .inrect {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }
  .bookitem {
    height: 200px;
    border-radius: 10px;
  }
  .bookitem-bottom{
    display: none;
  }
}



.bookitem:hover {
  /* transform: translateY(-5px);*/
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}



/* 响应式调整 */
@media (max-width: 768px) {
  .vh-full .el-scrollbar>.el-scrollbar__wrap>.el-scrollbar__view>div {
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 16px;
    padding: 16px;
  }

  .bookitem {
    height: 220px;
  }
}

@media (max-width: 480px) {
  .vh-full .el-scrollbar>.el-scrollbar__wrap>.el-scrollbar__view>div {
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 12px;
    padding: 12px;
  }

  .bookitem {
    height: 200px;
    padding: 12px;
  }

  .bookitem>div:first-child {
    font-size: 14px;
  }
}
</style>
